<script>


import {avatarBackground, avatarText} from "@/tools/avatar";
import {getDriverGPSServerInstance} from "@/data-services/driver-gps-service";
import {commonData} from "@/shared-services";

export default {
  name: "FlAvatar",

  props: {
    size: {
      type: Number,
    },
    imuser: {
      type: Object,
      default: null
    },
    nickname: {
      type: String,
    },
    fleetId: {
      type: Number
    },
    shape: {
      type: String,
      default: "circle",
      validator(val) {
        return ["circle", "square"].includes(val);
      }
    },
    src: String,
    alt: String,
    srcSet: String,
    error: Function,
    fit: {
      type: String,
      default: "cover"
    }
  },

  data() {
    return {
      isImageExist: true,
      mFleetId: 0,
      mSrc: null,
      mText: null,
      userObject: null,
      firstName:'',
      lastName:'',
    };
  },
  computed: {
    avatarClass() {
      const { size, shape } = this;
      let classList = ["fl-avatar"];

      if (size && typeof size === "string") {
        classList.push(`fl-avatar--${size}`);
      }


      if (shape) {
        classList.push(`fl-avatar--${shape}`);
      }

      return classList.join(" ");
    },
    internalText() {
      return avatarText(this.mText)
    }
  },

  mounted() {
    commonData.getName$().subscribe(x => {
      this.firstName = x.firstName;
      this.lastName = x.lastName;
    })
  },
  methods: {
    async avatarObject(fleetId) {
      try {
        return getDriverGPSServerInstance().getList().data.then(res => {
          const arr = res.data;
          for (let index in arr) {
            const x = arr[index]
            // console.log(x.driverId, fleetId)
            if (parseInt(x.driverId) === parseInt(fleetId)) {
              return x
            }
          }
        })
      } catch (e) {
        return ''
      }
    },
    async updateUserObject() {
      if (this.userObject) {
        return
      }
      const userObject = await this.avatarObject(this.mFleetId)
      console.log(userObject)
      if (userObject) {
        this.userObject = userObject;
      }
    },
    handleError() {
      const { error } = this;
      const errorFlag = error ? error() : undefined;
      if (errorFlag !== false) {
        this.isImageExist = false;
      }
    },
    initFleetId() {
      if(!this.fleetId) {
        if (this.imuser && this.imuser.account) {
          this.mFleetId = parseInt((this.imuser.account).split('_')[1])
        } else {
          this.mFleetId = 0
        }
      } else {
        this.mFleetId = this.fleetId
      }
    },
    initSrcAndText() {
      if (!this.src && !this.nickname) {
        if (this.imuser && this.imuser.avatar) {
          this.mSrc = this.imuser.avatar
          this.mText = this.imuser.nick || ''
        } else if (this.mFleetId !== 0) {
          this.updateUserObject()
          const obj = this.userObject;
          if (obj) {
            this.mSrc = obj.userImage
            this.mText = `${obj.firstName} ${obj.lastName}`
          }
        }
        else {
          this.mSrc = this.$store.state.user.avatarUrl
          this.mText = `${this.firstName} ${this.lastName}`
        }
      } else {
        this.mSrc = this.src
        this.mText = this.nickname
      }
    },
    renderAvatar() {
      const { alt, isImageExist, srcSet, fit } = this;


      if (isImageExist && this.mSrc) {
        return (
            <img
                src={this.mSrc}
                onError={this.handleError}
                alt={alt}
                srcSet={srcSet}
                style={{ "object-fit": fit }}
            />
        );
      }

      return (
          this.$slots.default || (
              <span
                  style={{
                    fontSize: this.size && this.size / 2.5 + "px",
                    fontWeight: "bold",
                    color: '#fff'
                  }}
              >
            {this.internalText}
          </span>
          )
      );
    }
  },

  render() {
    const { avatarClass, size } = this;
    this.initFleetId()
    this.initSrcAndText()

    const styleObject = {
      background: avatarBackground(this.mText),
      border: '1px solid #DEE5EF'
    };

    const sizeStyle =
        typeof size === "number" ? {
          height: `${size}px`,
          width: `${size}px`,
          display: 'inline-flex',
          'justify-content': 'center',
          'align-items': 'center'
        } : {};
    return (
        <span class={avatarClass} style={[styleObject, sizeStyle]}>
        {this.renderAvatar()}
      </span>
    );
  }
};
</script>
